export function RGBtoHEX(rgbArray) {
  const hex = rgbArray.reduce((prev, current) => {
    return prev + ('00' + (current).toString(16)).slice(-2)
  }, '')
  return `#${hex}`
}



// WEBPACK FOOTER //
// ./src/utilities/colors.js